module.exports = __webpack_public_path__ + "695c40d3.svg";